import {
  Avatar,
  Breadcrumb,
  Button,
  ButtonGroup,
  Card,
  Checkbox,
  CheckboxGroup,
  Col,
  DatePicker,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Form,
  FormItem,
  Header,
  Icon,
  Input,
  Layout,
  Menu,
  MenuGroup,
  MenuItem,
  Message,
  Modal,
  Option,
  Page,
  Row,
  Select,
  Sider,
  Spin,
  Submenu,
  Switch,
  Table,
  Tag,
  Tooltip,

  i18n,
  locale,
} from 'iview';

// ToDo register local component not used frecuently

const iview = {
  iAvatar: Avatar,
  iBreadcrumb: Breadcrumb,
  iButton: Button,
  iButtonGroup: ButtonGroup,
  iCard: Card,
  iCheckbox: Checkbox,
  iCheckboxGroup: CheckboxGroup,
  iCol: Col,
  iDatePicker: DatePicker,
  iDropdown: Dropdown,
  iDropdownItem: DropdownItem,
  iDropdownMenu: DropdownMenu,
  iForm: Form,
  iFormItem: FormItem,
  iHeader: Header,
  iIcon: Icon,
  iInput: Input,
  iLayout: Layout,
  iMenu: Menu,
  iMenuGroup: MenuGroup,
  iMenuItem: MenuItem,
  iMessage: Message,
  iModal: Modal,
  iOption: Option,
  iPage: Page,
  iRow: Row,
  iSelect: Select,
  iSider: Sider,
  iSpin: Spin,
  iSubmenu: Submenu,
  iSwitch: Switch,
  iTable: Table,
  iTag: Tag,
  iTooltip: Tooltip,

  Option, // compatibility https://github.com/iview/iview/issues/3834
};

const install = (Vue, opts = {}) => { /* eslint-disable no-param-reassign */
  if (install.installed) return;
  locale(opts.locale);
  i18n(opts.i18n);

  Object.keys(iview).forEach((key) => {
    Vue.component(key, iview[key]);
  });

  Vue.prototype.$IVIEW = {
    size: 'size' in opts ? opts.size : '',
    transfer: 'transfer' in opts ? opts.transfer : '',
  };

  // Vue.prototype.$Loading = LoadingBar;
  Vue.prototype.$Message = Message;
  Vue.prototype.$Modal = Modal;
  // Vue.prototype.$Notice = Notice;
  Vue.prototype.$Spin = Spin;
};

export default {
  install,
};
